import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBananas: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBananas"><Path d="M6.5 3.5L3.49988 4V7.74328C0.864313 11.3755 3.76345 18.3228 10.0457 19.9164C16.3279 21.5101 21.4999 17.0544 21.4999 13.7343L20.5927 12.8655C14.7255 15.8941 7.34105 15.8374 6.5 7.74328V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5016 14.1C19.0016 12.6 19.3391 10.7159 19.5016 10L18.5016 9.25C18.5016 9.25 13.0015 15 6.60156 8" stroke="currentColor"/></CentralIconBase>;
});

export default IconBananas;
